import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'horario-culto-modulo',
  templateUrl: './horario-culto-modulo.component.html',
  styleUrls: ['./horario-culto-modulo.component.scss']
})
export class HorarioCultoModuloComponent implements OnInit {

  @Input("data") data:any     = null; 
  @Input("template") template = null;
  public dataItem:any         = {};
  public loader               = false;
  
  constructor(){}

  /**
   * 
   * Init
   * 
   */
  ngOnInit():void{}

}
